module.exports = "/assets/logo_sg_premierepro_1_1-28f23ef9889d602471690c56cdf50011.png";